import {makeQueryStringData} from "./Utils";

export default class {
    static send(params = {}, successCallback, errorCallback) {
        if (!params.url) return;
        const defaultsParams = {
          json: false,
          data: {},
          formData: false
        };

        Object.assign(defaultsParams, params);

        const request = new XMLHttpRequest();
        const data = defaultsParams.json ?
            // json
            (defaultsParams.data ? JSON.stringify(defaultsParams.data) : {}) :
            // standard POST/GET - string data
            defaultsParams.formData ? defaultsParams.data : makeQueryStringData(defaultsParams.data);

        const method = defaultsParams.method || "POST";

        request.open(method, defaultsParams.url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        defaultsParams.json ?
            request.setRequestHeader("Content-type","application/json") :
            !defaultsParams.formData ? request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded') : null;

        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                // Success!
                if (typeof successCallback === 'function') {
                    const response = (typeof request.response === "object") ? request.response : JSON.parse(request.response);
                    successCallback(response);
                }
            } else {
                // We reached our target server, but it returned an error
                if (typeof errorCallback === 'function') {
                    errorCallback(request.responseText);
                }
            }
        };

        request.onerror = () => {
            // There was a connection error of some sort
            if (typeof errorCallback == 'function') {
                errorCallback();
            }
        };

        request.send(data);
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/common/XHR.js